import type { NavigationEntry } from "@positive/ui";
import "@ui5/webcomponents-icons/dist/accounting-document-verification.js";
import "@ui5/webcomponents-icons/dist/activity-items.js";
import "@ui5/webcomponents-icons/dist/appointment-2.js";
import "@ui5/webcomponents-icons/dist/bar-chart.js";
import "@ui5/webcomponents-icons/dist/customer-financial-fact-sheet.js";
import "@ui5/webcomponents-icons/dist/delete.js";
import "@ui5/webcomponents-icons/dist/journey-arrive.js";
import "@ui5/webcomponents-icons/dist/money-bills.js";
import "@ui5/webcomponents-icons/dist/org-chart.js";
import "@ui5/webcomponents-icons/dist/project-definition-triangle.js";
import "@ui5/webcomponents-icons/dist/settings.js";
import "@ui5/webcomponents-icons/dist/table-chart.js";

import { glPermissions } from "./permissions";

/** General Ledger entries of the navigation registry (group `generalLedger`, plan module `gl`). */
export const generalLedgerNavigation: readonly NavigationEntry[] = [
  {
    key: "gl.vouchers",
    labelKey: "nav.journalVouchers",
    icon: "accounting-document-verification",
    path: "/gl/journal-vouchers",
    permission: glPermissions.voucherView,
  },
  {
    key: "gl.entries",
    labelKey: "nav.journalEntries",
    icon: "activity-items",
    path: "/gl/journal-entries",
    permission: glPermissions.entryView,
  },
  {
    key: "gl.recurring",
    labelKey: "nav.recurringJournals",
    icon: "journey-arrive",
    path: "/gl/recurring-journals",
    permission: glPermissions.recurringView,
  },
  {
    key: "gl.trialBalance",
    labelKey: "nav.trialBalance",
    icon: "table-chart",
    path: "/gl/reports/trial-balance",
    permission: glPermissions.trialBalanceView,
  },
  {
    key: "gl.statement",
    labelKey: "nav.statementOfAccount",
    icon: "customer-financial-fact-sheet",
    path: "/gl/reports/statement",
    permission: glPermissions.statementView,
  },
  {
    key: "gl.financialStatements",
    labelKey: "nav.financialStatements",
    icon: "bar-chart",
    path: "/gl/reports/financial-statements",
    permission: glPermissions.financialStatementsView,
  },
  {
    key: "gl.costCentreReport",
    subGroup: "reports",
    labelKey: "nav.costCentreReport",
    icon: "org-chart",
    path: "/gl/reports/cost-centres",
    permission: glPermissions.costCenterReportView,
  },
  {
    key: "gl.projectReport",
    subGroup: "reports",
    labelKey: "nav.projectReport",
    icon: "project-definition-triangle",
    path: "/gl/reports/projects",
    permission: glPermissions.projectReportView,
  },
  {
    key: "gl.deletedVouchers",
    subGroup: "reports",
    labelKey: "nav.deletedVouchers",
    icon: "delete",
    path: "/gl/reports/deleted-vouchers",
    permission: glPermissions.deletedVouchersView,
  },
  {
    key: "gl.fiscalYears",
    subGroup: "periodEnd",
    labelKey: "nav.fiscalYears",
    icon: "appointment-2",
    path: "/gl/fiscal-years",
    permission: glPermissions.fiscalYearView,
  },
  {
    key: "gl.revaluation",
    subGroup: "periodEnd",
    labelKey: "nav.revaluation",
    icon: "money-bills",
    path: "/gl/revaluation",
    permission: glPermissions.revaluationView,
  },
  {
    key: "gl.settings",
    subGroup: "periodEnd",
    labelKey: "nav.ledgerSettings",
    icon: "settings",
    path: "/gl/settings",
    permission: glPermissions.settingsView,
  },
];
